import type { SocialPlatform } from "@garimpa/lib/musicTypes";

const HOST_PLATFORMS: ReadonlyArray<[suffix: string, platform: SocialPlatform]> = [
  ["spotify.com", "spotify"],
  ["youtube.com", "youtube"],
  ["youtu.be", "youtube"],
  ["instagram.com", "instagram"],
  ["facebook.com", "facebook"],
  ["twitter.com", "twitter"],
  ["x.com", "twitter"],
  ["soundcloud.com", "soundcloud"],
  ["bandcamp.com", "bandcamp"],
];

/** The known social/streaming platform an external URL points to, if any. */
export function socialPlatformForUrl(url: string): SocialPlatform | null {
  let host: string;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
  const match = HOST_PLATFORMS.find(([suffix]) => host === suffix || host.endsWith(`.${suffix}`));
  return match ? match[1] : null;
}
